var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowComponent
    ? _c(
        "div",
        { staticClass: "energy-container", class: _vm.containerClasses },
        [
          _vm.lazyLoad
            ? _c("lazy-img", {
                staticClass: "energy-label-button img-fluid",
                attrs: {
                  "image-url": _vm.parsedImageUrl,
                  alt: _vm.parsedImageAlt,
                  title: _vm.parsedImageAlt
                },
                on: {
                  click: function($event) {
                    return _vm.handleClick()
                  }
                }
              })
            : _c("img", {
                staticClass: "energy-label-button img-fluid",
                attrs: {
                  src: _vm.parsedImageUrl,
                  alt: _vm.parsedImageAlt,
                  title: _vm.parsedImageAlt,
                  loading: "lazy"
                },
                on: {
                  click: function($event) {
                    return _vm.handleClick()
                  }
                }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }